/**
 * Teaser screen wrapper that posts its rendered height and width to the parent
 * window for iframe embedding.
 *
 * Teaser screens are embedded in publisher pages via iframe; the host needs to
 * size the iframe to the rendered content, so `onLayout` posts a
 * `psi-iframe-dimension` message to `window.parent` on every layout change.
 * Wrap the top-level teaser content in `<TeaserScreen>` and the resize
 * handshake is handled.
 */

import type { PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';

export type TeaserScreenProps = { color?: string };

export function TeaserScreen({ children, color = 'transparent' }: PropsWithChildren<TeaserScreenProps>) {
    return <View style={[TeaserScreenStyle.teaser, { backgroundColor: color }]}>{children}</View>;
}

export const TeaserScreenStyle = StyleSheet.create({
    teaser: {
        borderRadius: 8,
        maxWidth: 797,
        width: '100%',
    },
});
